import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Layout } from "./components/Layout";
import { About } from "./pages/About";
import { Artist } from "./pages/Artist";
import { ChartView } from "./pages/Chart";
import { Discover } from "./pages/Discover";
import { Home } from "./pages/Home";
import { NotFound } from "./pages/NotFound";
import { Search } from "./pages/Search";
import { Track } from "./pages/Track";
import "@fontsource-variable/plus-jakarta-sans";
import "./styles.css";

const client = new QueryClient({
  defaultOptions: { queries: { retry: (n, err) => n < 2 && !(err as { status?: number }).status, refetchOnWindowFocus: false, staleTime: 60_000 } },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={client}>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="szukaj" element={<Search />} />
            <Route path="listy" element={<Navigate to="/listy/rmf-fm-poplista" replace />} />
            <Route path="listy/:chart/:date?" element={<ChartView />} />
            <Route path="utwor/:id" element={<Track />} />
            <Route path="wykonawca/:id" element={<Artist />} />
            <Route path="odkrywaj" element={<Discover />} />
            <Route path="o-projekcie" element={<About />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
